import api from './axiosInstance';

// Configuración de validadores EEPP (asignación por tipo de escritura + capacidad).
// Backend: EscriturasValidatorController (api/escrituras/validators). Upsert +
// soft-inactive sobre usuarios EEPP existentes (sin crear/borrar) + reasignación
// manual de la escritura vía api/escrituras/{escrituraId}/assign.

/**
 * Lista de usuarios EEPP con su configuración (para el CRUD de Configuración).
 *
 * Cada fila incluye la config de supervisor SLA (supervisorUserId +
 * supervisorUserName, resuelto por el backend); ambos pueden venir null.
 */
export const getValidators = async (signal) => {
  const response = await api.get('/escrituras/validators', { signal });
  return response.data || [];
};

/** Validadores elegibles (para el dropdown de reasignación manual). */
export const getActiveValidators = async (signal) => {
  const response = await api.get('/escrituras/validators/active', { signal });
  return response.data || [];
};

/**
 * Upsert de la config de un validador: tipos atendidos + capacidad (tiempos) +
 * supervisor SLA (supervisorUserId, int|null; null = sin supervisor).
 */
export const upsertValidator = async (
  userId,
  { writingTypeCodes, capacityTiempos, supervisorUserId },
  signal
) => {
  const response = await api.put(
    `/escrituras/validators/${userId}`,
    { writingTypeCodes, capacityTiempos, supervisorUserId },
    { signal }
  );
  return response.data;
};

/** Activa/desactiva (soft-inactive) la config de un validador. */
export const setValidatorActive = async (userId, isActive, signal) => {
  const response = await api.patch(
    `/escrituras/validators/${userId}/active`,
    { isActive },
    { signal }
  );
  return response.data;
};

/** Reasigna manualmente una escritura a un validador (override consciente). */
export const assignValidatorToEscritura = async (
  escrituraId,
  validatorUserId,
  signal
) => {
  const response = await api.patch(
    `/escrituras/${escrituraId}/assign`,
    { validatorUserId },
    { signal }
  );
  return response.data;
};
